var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"multiple":"","filterable":false,"options":_vm.options,"placeholder":_vm.placeholder},on:{"input":val => { _vm.onChange(val); },"search":(search, loading) => { _vm.onInput(search, loading); }},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }